"use client";

import React from "react";
import type { IListing } from "@/src/shared/types/listing";
import { listingService } from "../services";
import CancellationPolicy from "./CancellationPolicy";
import HouseRules from "./HouseRules";

interface IThingsToKnowProps {
  listing: IListing;
}

const ThingsToKnow: React.FC<IThingsToKnowProps> = ({ listing }) => {
  const houseRules = React.useMemo(
    () => listingService.buildHouseRules(listing),
    [listing],
  );
  const cancellation = listing.cancellation?.body;
  if (!cancellation && !houseRules) return null;

  return (
    <section>
      <h2 className="text-xl font-semibold text-ink md:text-22">
        Things to know
      </h2>
      <div className="mt-5 grid gap-6 md:grid-cols-2 md:gap-8">
        {cancellation && <CancellationPolicy body={cancellation} />}
        {houseRules && <HouseRules rules={houseRules} />}
      </div>
    </section>
  );
};

export default ThingsToKnow;
